// extracted by mini-css-extract-plugin
export default {"row":"sB6CuuvOiiJjN2ngbq9c","halfWidth":"kh3fYfnfA0QsCMKsyjYT"};